import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Link from 'next/link';
import backButton from 'public/static/images/back-icon.svg';

function BackSubNav({ url, title }) {
  const { t } = useTranslation();
  return (
    <section>
      <div className="container _no-padding">
        <div className="row -small-gutters">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <Link href={url}>
              <a>
                <img src={backButton} alt="Back button" />
                {t('article.back', { title })}
              </a>
            </Link>
          </div>
        </div>
      </div>
      <style jsx>{`
        section {
          box-shadow: inset 0 7px 9px -7px #cacdd0;
          padding-top: 10px;
          padding-bottom: 10px;
        }

        a {
          color: red;
        }

        img {
          margin-right: 4px;
          padding-bottom: 5px;
        }
      `}</style>
    </section>
  );
}

BackSubNav.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default BackSubNav;
